import { render, staticRenderFns } from "./GeneralSendLogs.vue?vue&type=template&id=3007ff0d&"
import script from "./GeneralSendLogs.vue?vue&type=script&lang=js&"
export * from "./GeneralSendLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports